import { FaFileAlt, FaUserPlus, FaChartLine } from "react-icons/fa"; 

export const clients = [
    {
      name: "Sarah Company",
      email: "client1@example.com",
      company: "Tech Startup Inc",
      status: "Active",
      invited: "10/01/2024",
      totalSales: "£ 15,000",
    },
    {
      name: "Mike Pending",
      email: "mike@example.com",
      company: "Consulting LLC",
      status: "Pending",
      invited: "01/02/2024",
      totalSales: "£ 8,500",
    },
    {
      name: "Sreejith",
      email: "sreejith@example.com",
      company: "masters private ltd",
      status: "Pending",
      invited: "01/02/2024",
      totalSales: "£ 6,900",
    },
    {
      name: "Karthik",
      email: "compnaydone@example.com",
      company: "Compnay ptv ltd",
      status: "Pending",
      invited: "01/02/2024",
      totalSales: "£ 3,600",
    },
    {
      name: "Suresh",
      email: "polythin@gmail.com",
      company: "polythin private ltd",
      status: "Pending",
      invited: "01/02/2024",
      totalSales: "£ 10,500",
    },
  ];

  export const documents_data = [
    {
      fileName: "Invoice-jan-2024.pdf",
      name: "Sarah Client",
      company: "Tech Startup Inc",
      type: "Invoice",
      status: "Active",
      uploaded: "10/01/2024",
    },
    {
      fileName: "Expense-report-feb-2024.pdf",
      name: "Mike Pending",
      type: "Expense Report",
      company: "Consulting LLC",
      status: "completed",
      uploaded: "01/02/2024",
    },
  ];


  export const activities = [
    {
      Icon: FaFileAlt,
      color: "blue",
      title: "New document uploaded",
      desc: "Sarah company uploaded invoice-jan-2024.pdf",
      time: "2 hours ago",
    },
    {
      Icon: FaUserPlus,
      color: "green",
      title: "Company invitation sent",
      desc: "Invitation sent to mike@example.com",
      time: "1 day ago",
    },
    {
      Icon: FaChartLine,
      color: "teal",
      title: "Expense recorded",
      desc: "Sarah company added $85.50 expense",
      time: "3 days ago",
    },
  ];

  export const upcomingEvents = [
    {
      title: "Mock 1",
      date: "15 October 2024",
    },
    {
      title: "Mock 2",
      date: "20 October 2024",
    },
    {
      title: "Mock 3",
      date: "25 October 2024",
    },
    {
      title: "Mock 3",
      date: "25 October 2024",
    },
    {
      title: "Mock 3",
      date: "25 October 2024",
    },
    {
      title: "Mock 3",
      date: "25 October 2024",
    },
  ];